import { useState } from "react"
import { Router, navigate } from "@reach/router"
import { arrayOf, shape, string, number, bool, object } from "prop-types"
import { QuestionList } from "./QuestionList/index"
import NewQuestion from "./NewQuestion"
import EditQuestion from "./EditQuestion"
import sortBy from "utils/sorter"

const Questions = ({
  questions: questionsFromProps = [],
  blankStateImageURL,
  signup,
  questionOrderPath,
  selectionsUrl,
  formsUrl,
  attendeeQuestionsUrl,
  group,
  isActingStaff,
  creditCardKeywords
}) => {
  const { routerBasePath } = window
  const dirOptionsByGroup = {
    registrant: "collect",
    attendee_form: "forms",
    attendee: "collect/attendee_settings"
  }
  const dir = dirOptionsByGroup[group]
  const basePath = `${routerBasePath}signups/${signup.id}/${dir}`
  const savePath = `${routerBasePath}signups/${signup.id}/questions`
  const [questions, setQuestions] = useState(questionsFromProps)

  const handleSave = newQuestion => {
    setQuestions(
      sortBy("position", [...questions.filter(q => q.id != newQuestion.id), newQuestion])
    )
    navigate(basePath)
  }

  const handleCancel = () => {
    navigate(basePath)
  }

  const handleDelete = question => {
    return alertModal(
      {
        title: "Deleted!",
        text: "Your question and any answers have been deleted.",
        type: "success",
        confirmButtonText: "Ok"
      },
      () => {
        setQuestions(questions.filter(q => q.id !== question.id))
        navigate(basePath)
      }
    )
  }

  const handleReorder = sorteQuestions => {
    setQuestions(sorteQuestions)
  }

  return (
    <div className="max-width-center-stage">
      <Router basepath={basePath}>
        <NewQuestion
          group={group}
          path={`/new`}
          basePath={basePath}
          savePath={savePath}
          signup={signup}
          onSave={handleSave}
          onCancel={handleCancel}
          creditCardKeywords={creditCardKeywords}
        />
        <EditQuestion
          group={group}
          questions={questions}
          path={`:questionId/edit`}
          basePath={basePath}
          savePath={savePath}
          signup={signup}
          onSave={handleSave}
          onCancel={handleCancel}
          onDelete={handleDelete}
          creditCardKeywords={creditCardKeywords}
        />
        <QuestionList
          group={group}
          path={"/"}
          basePath={basePath}
          default={true}
          questions={questions}
          blankStateImageURL={blankStateImageURL}
          questionOrderPath={questionOrderPath}
          signup={signup}
          selectionsUrl={selectionsUrl}
          formsUrl={formsUrl}
          attendeeQuestionsUrl={attendeeQuestionsUrl}
          onReorder={handleReorder}
          isActingStaff={isActingStaff}
        />
      </Router>
    </div>
  )
}

Questions.propTypes = {
  group: string.isRequired,
  questions: arrayOf(object),
  blankStateImageURL: string,
  questionOrderPath: string,
  signup: shape({ id: number, isSimpleEvent: bool }),
  selectionsUrl: string,
  formsUrl: string,
  attendeeQuestionsUrl: string,
  isActingStaff: bool,
  creditCardKeywords: arrayOf(string)
}

export default Questions
